export const TRACKER_TYPE = 'trackStructEvent';
export const CATEGORY = 'ad_pill_tooltip_overlay';
export const LABEL = 'serp_page';
export const ACTION_IMPRESSION = 'display';
export const ACTION_CLICK = 'click';
export const VALUE = '0';
export const CONTEXT = [];

export const trackAdPillTooltipShown = (property) => ({
  tracker: TRACKER_TYPE,
  data: {
    category: CATEGORY,
    action: ACTION_IMPRESSION,
    label: LABEL,
    property,
    value: VALUE,
  },
  context: CONTEXT,
});

export const trackAdPillTooltipClick = (property) => ({
  tracker: TRACKER_TYPE,
  data: {
    category: CATEGORY,
    action: ACTION_CLICK,
    label: LABEL,
    property,
    value: VALUE,
  },
  context: CONTEXT,
});
